import {Component, forwardRef, Inject, Injector, OnInit} from '@angular/core';
import {SessionService} from '../../services/session.service';
import {TranslateService} from '@ngx-translate/core';
import {ModalDismissReasons, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {WeeklyWorkShift} from "./model/WeeklyWorkShift";

@Component({
  templateUrl: './WorkShiftRowHeaderComponent.html'
})

export class WorkShiftRowHeaderComponent implements OnInit {

  // @Input() jobLabel: string;
  // @Input() startTime: string;
  // @Input() endTime: string;

  model: WeeklyWorkShift;

  // weeklyWorkShiftComponent: WeeklyWorkShiftComponent;

  constructor (private injector: Injector, private modalService: NgbModal,
               @Inject(forwardRef(() => SessionService)) private session: SessionService,
               private translate: TranslateService) {

    this.model = this.injector.get('model');
    this._init();

  }

  private _init(){
    //
    // this.jobLabel = this.model.jobAndUnitInfo.job.description;
    // this.startTime = this.model.startTime this.injector.get('startTime');
    // this.endTime = this.injector.get('endTime');
    // this.weeklyWorkShiftComponent = this.injector.get('ducon');

    // this.schedules = this.model.schedulesByDay(this.dayType);
    // this.refDate = this.model.getRefDate(this.dayType);
    // this.validateForErrors();
  }


  ngOnInit() {

  }

  isPlanningOK(): boolean {
    /*
    if (this.workShift.missingPlanningDetails) {
      if (this.workShift.missingPlanningDetails.length > 0) {
         return false;
      }
    }
    if (this.workShift.tooManyScheduledDays) {
      if (this.workShift.tooManyScheduledDays.length > 0) {
        return false;
      }
    } */
    // console.log('isPlanningOK: ' + Array.from(this.workShift.errorPlanningDetails.keys()).length + ' obj: ' + JSON.stringify(this.workShift.errorPlanningDetails, null, 1 ));
    if (this.model.errorPlanningDetails && Array.from(this.model.errorPlanningDetails.keys()).length > 0 ) {
       for ( const k of Array.from(this.model.errorPlanningDetails.keys()) ){
//         console.log("planning: " +  k + ': ' + this.model.errorPlanningDetails.get(k));
       }
      return false;
    }
   return true;
  }

  retrieveTooManyErrors(): string[] {
    const res = new Array<string>();
    for ( const k of Array.from(this.model.errorPlanningDetails.keys()) ){
      const nb = this.model.errorPlanningDetails.get(k);
      if ( nb > 0 ) {
        res.push(this.translate.instant('TooManyPlanning', {dayOfWeek: this.translate.instant(k) , qty: nb}));

      }
    }
    return res;
  }

  retrieveMissingErrors(): string[] {
    const res = new Array<string>();
    for ( const k of Array.from(this.model.errorPlanningDetails.keys()) ){
      const nb = this.model.errorPlanningDetails.get(k);
      if ( nb < 0 ) {
        // Displaying just positive numbers => * -1
        res.push(this.translate.instant('MissingPlanning', {dayOfWeek: this.translate.instant(k) , qty: -1 * nb}));

      }
    }
    return res;
  }

  hasTooManyScheduledDays(): boolean {
    for ( const k of Array.from(this.model.errorPlanningDetails.keys())){
      if (this.model.errorPlanningDetails.get(k) > 0 ) {
        return true;
      }
    }
    /*
    if (this.workShift.tooManyScheduledDays) {
      if (this.workShift.tooManyScheduledDays.length > 0) {
        return true;
      }
    } */
    return false;
  }

  hasMissingPlanningDetails(): boolean {
    for ( const k of Array.from(this.model.errorPlanningDetails.keys())){
      if (this.model.errorPlanningDetails.get(k) < 0 ) {
        return true;
      }
    }
    // if (this.workShift.missingPlanningDetails) {
    //   if (this.workShift.missingPlanningDetails.length > 0) {
    //     return true;
    //   }
    // }
    return false;
  }



  onClick() {
    /*

    const modalRef = this.modalService.open(DlgAddWorkshiftComponent);

    modalRef.componentInstance.jobs = this.session.jobManager.getAllJobsOrdered();
    modalRef.componentInstance.populate(this.model.startTime, this.model.endTime);

    modalRef.result.then((result) => {
      console.log( `Closed with: ${result}`);
      if ( result) {
        const ws = <WeeklyWorkShift> result;
        this.model.jobAndUnitInfo = ws.jobAndUnitInfo;
        this.model.populateFromInterval(ws.interval);
        //this.model.s.syncWithModel();
      }
    }, (reason) => {
      console.log(`Dismissed ${this.getDismissReason(reason)}`);
    });
    */
  }




  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }



}
